import Vue from 'vue'
import HolidayDatesCard from './cards/holidayDates/HolidayDatesCard'
import ServerAccessCard from './cards/serverAccess/ServerAccessCard'
import AdminUsersCard from './cards/adminUsers/AdminUsersCard'
import LogisticsSettingsCard from './cards/logisticsSettings/LogisticsSettingsCard'
import MileageRatesCard from './cards/mileageRates/MileageRatesCard'
import SpecialtyTypesCard from './cards/specialtyTypes/SpecialtyTypesCard'
import ExpiryCredNoticeEmailCard from './cards/expiryCredNoticeEmail/ExpiryCredNoticeEmailCard'
import ExpiryCertNoticeEmailCard from './cards/expiryCertNoticeEmail/ExpiryCertNoticeEmailCard'
import ExpiryStateLicenseNoticeEmailCard from './cards/expiryStateLicenseNoticeEmail/ExpiryStateLicenseNoticeEmailCard'
import ExpiryDEALicenseNoticeEmailCard from './cards/expiryDEALicenseNoticeEmail/ExpiryDEALicenseNoticeEmailCard'
import UpdatePasswordCard from './cards/updatePassword/UpdatePasswordCard'
import {allUserRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import EmailSettingCard from "@/componentsReusable/cards/emailSetting/EmailSettingCard";
import PresidentsGoalCard from "@/components/settings/cards/presidentsgoal/PresidentsGoalCard";
import RepresentativeGoalCard from "@/components/settings/cards/nmremployee/RepresentativeGoalCard";
import MalpracticeInsurancePanel from "@/components/settings/cards/malpracticeinsurance/MalpracticeInsurancePanel";
import BirthdayMessageCard from "@/components/settings/cards/BirthdayMessage/BirthdayMessageCard";
import PostmarkSenderSignaturesCard from "@/components/settings/cards/postmark-sender-signatures/PostmarkSenderSignaturesCard";

export default Vue.extend({
  name: 'Settings',
  components: {
    HolidayDatesCard,
    ServerAccessCard,
    AdminUsersCard,
    LogisticsSettingsCard,
    MileageRatesCard,
    PresidentsGoalCard,
    RepresentativeGoalCard,
    SpecialtyTypesCard,
    EmailSettingCard,
    ExpiryCredNoticeEmailCard,
    ExpiryCertNoticeEmailCard,
    ExpiryStateLicenseNoticeEmailCard,
    ExpiryDEALicenseNoticeEmailCard,
    UpdatePasswordCard,
    MalpracticeInsurancePanel,
    BirthdayMessageCard,
    PostmarkSenderSignaturesCard
  },
  data () {
    return {
      cardExpanded: true,
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      isManager: false,
      isAuthorizedForMalpracticeCard: false
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](allUserRoles);
    this.isManager = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
    this.isAuthorizedForMalpracticeCard = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER, UserRoleEnum.ACCOUNTANT, UserRoleEnum.CREDENTIALER]);
  },
})



// WEBPACK FOOTER //
// ./src/components/settings/Settings.ts